pageId = 'page-project'
page = "##{ pageId }"

$ ->
  html = $('html')
  $('.wrapper')
    .on 'click', "#{ page } .project-footer .link-show-section", addProjectSection

    .on 'click', "#{ page } .btn-new-todolist, #{ page } .btn-new-todo", ->
      $('.init.init-todos').hide()
      unless $('.todos-all[group-by="nothing"]').length
        filter = document.querySelector('tr-project-todo-group-filter')
        filter.field.value = 'nothing'
        filter.sumbit()
        return false
    .on 'ajax:success', "#{ page } .btn-new-todo", ->
      $('.default-todolist tr-todo-form').one 'tao:removed', ->
        if $('.default-todolist tr-todo-item').length == 0
          $('.init.init-todos').show()
        else
          $('.init.init-todos').remove()

  $(document)
    .on 'click', "#{ page } .link-show-todolist-form", ->
      $link = $(@)
      $link.hide()
      $link.next().css
        display: 'inline-block'
      .find('.todolist-name')
      .focus()

    .on 'click', "#{ page } .btn-cancel-todolist", ->
      $('.link-show-todolist-form').show()

    .on 'todoupdate', page, ->
      $link = $('.project-view-switch-item.active[data-type="member"]')
      $link.trigger('click') if $link.length

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  $('#nav-project').addClass 'active'

  # init todos
  $sectionTodos = $page.find('.section-todos')
  if $sectionTodos.length
    tower.adjustTodo()

    if $sectionTodos.find('.todos-all[group-by="nothing"]').length
      tower.sortTodolists()
      tower.adjustTodolist()

  # init docs
  if $page.find('.section-docs').length
    tower.initDocViews()
    tower.initDocDnD $page
    $page.find('.doc-list a[data-stack-replace]')
      .removeAttr 'data-stack-replace'

  # init files
  $sectionFiles = $page.find('.section-files')
  if $sectionFiles.length
    tower.initFileUpload
      beforeUpload: ->
        $sectionFiles.find('.files-view .file-list .file-or-dir:gt(9)').remove()

    tower.initFileViews()
    tower.initFileDnD $page
    $sectionFiles.find('.file-or-dir a[data-stack-replace]')
      .removeAttr 'data-stack-replace'

    # 拖拽上传文件
    simple.filedrop
      el: $sectionFiles
      hints: '拖拽到这里上传'
    .on 'drop', (e, files) ->
      $btn = $sectionFiles.find('.btn-upload-file')
      uploader = $btn.data('uploader')

      if !tower.isScreenView($btn)
        simple.scrollTo target: $btn
      if files
        $.each files, (i, file) ->
          uploader.upload file

  initNormalProject()

initNormalProject = ->
  $footer = $('.project-footer')
  return unless $footer.length

  $('.project-sections > div').each ->
    $footer.find('.link-show-section').filter("[data-type=#{ $(@).attr('id') }]").remove()

  if $footer.find('.link-show-section').length is 0
    $footer.find('.section-control .prefix').remove()

addProjectSection = ->
  $link = $(@)

  simple.loading
    type: 'tiny'
    el: $link

  order = JSON.parse $('#project-sections-order').val()
  order.push $link.data('section') * 1

  $.ajax
    url: $link.parent().data('url')
    type: 'post'
    data:
      sections: order.getUnique()
    success: ->
      tower.stack.load location.href,
        noCache: true
        replace: true
